<template>
  <g
    class="x-axis"
    :transform="`translate(0, ${
      c.xAxisPosition === 'bottom'
        ? p.scaleY(p.minY)
        : c.legendPosition === 'top'
        ? +c.globalMarginTop + +c.legendHeight
        : +c.globalMarginTop
    })`"
  >
    <g v-for="(datum, index) in p.ticksX" :key="index">
      <line
        :class="[
          'x-axis-tick',
          {
            selected:
              p.tooltipMove &&
              p.tooltipMove.datum &&
              p.tooltipMove.datum[c.xAxis] == datum,
          },
        ]"
        :x1="p.scaleX(datum)"
        :x2="p.scaleX(datum)"
        :y1="c.xAxisPosition === 'top' ? c.xAxisHeight : 0"
        :y2="
          c.xAxisPosition === 'top'
            ? c.xAxisHeight - +c.xAxisTickHeight
            : +c.xAxisTickHeight
        "
        :style="{
          stroke: c.xAxisTickStrokeColor,
          strokeWidth: c.xAxisTickStrokeWidth,
        }"
      />

      <text
        :class="[
          'x-axis-label',
          {
            selected:
              p.tooltipMove &&
              p.tooltipMove.datum &&
              p.tooltipMove.datum[c.xAxis] == datum,
          },
        ]"
        :x="p.scaleX(datum)"
        :y="c.xAxisPosition === 'bottom' ? +c.xAxisHeight : +c.xAxisFontSize"
        text-anchor="middle"
        :fontSize="c.xAxisFontSize"
        :style="{ fontSize: c.xAxisFontSize, fill: 'white' }"
        :transform="
          c.xAxisTranslate &&
          `translate(${c.xAxisTranslate.x}, ${c.xAxisTranslate.y})`
        "
      >
        <!-- TODO  -->
        <!-- {{ d[index] && d.find(o => o[c.xAxis] == datum).label ? d.find(o => o[c.xAxis] == datum).label : datum }} -->
        {{ datum }}
      </text>
    </g>
  </g>
</template>

<script>
export default {
  props: ["p", "c", "d", "serie"],
  data() {
    return {
      labelPadding: 15,
    };
  },
};
</script>

<style lang="scss" scoped>
.x-axis {
  .x-axis-label {
    text-anchor: middle;
    fill: #000;
    @include dida-S;
    &.selected {
      fill: red;
    }
  }
}
</style>
